/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ServiceNowCmdbSyncLogSortColumn {
    SyncTime = 'SyncTime',
    Service = 'Service',
    Status = 'Status',
    Action = 'Action',
    ResourceType = 'ResourceType',
    ResourceId = 'ResourceId'
}
